import classNames from "classnames"
import ToggleSwitch from "legacy/ToggleSwitch"
import { capitalizeFirstLetter, inchesToFeet } from "legacy/helpers.es6.jsx"
import RateCalendar from "legacy/pricing/RateCalendar"
import RateForm from "legacy/pricing/RateForm"
import SpaceRateForm from "legacy/pricing/SpaceRateForm"
import moment from "moment"
import PropTypes from "prop-types"
import React from "react"

import Badge from "src/components/Badge"
import Modal from "src/components/Modal"

import { formatCurrencyFromMinorUnits } from "src/utils/UnitConversion"

// Note: jQuery ($) is loaded globally

class PricingController extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      rateCalendar: null,
      spaceRates: [],
      namedRates: [],
      spaceRateModalOpen: false,
      selectedSpaceRate: null,
      spaceRateFormErrorMessage: null,
      rateModalOpen: false,
      selectedRate: null,
      rateFormErrorMessage: null,
      togglePosition: "left",
    }

    this.toggleChange = this.toggleChange.bind(this)
    this.newSpaceRate = this.newSpaceRate.bind(this)
    this.saveSpaceRate = this.saveSpaceRate.bind(this)
    this.deleteSpaceRate = this.deleteSpaceRate.bind(this)
    this.renderSpaceRate = this.renderSpaceRate.bind(this)
    this.newRate = this.newRate.bind(this)
    this.saveRate = this.saveRate.bind(this)
    this.renderRate = this.renderRate.bind(this)
    this.presentmentCurrency =
      window.currentMarina?.presentmentCurrency || "USD"
  }

  get baseUrl() {
    return `/manage/${this.props.marinaSlug}`
  }

  get spaceRateUrl() {
    return `${this.baseUrl}/space_rates`
  }

  get namedRateUrl() {
    return `${this.baseUrl}/rates`
  }

  get showActiveRates() {
    return this.state.togglePosition === "left"
  }

  componentDidMount() {
    this.fetchRates()
  }

  fetchRates() {
    this.fetchSpaceRates()
    this.fetchNamedRates()
  }

  fetchSpaceRates() {
    let data = {}
    if (this.showActiveRates) {
      data = { filter: "active" }
    } else {
      data = { filter: "inactive" }
    }
    return $.get(this.spaceRateUrl, data, (spaceRates) => {
      this.setState({ spaceRates })
    })
  }

  fetchNamedRates() {
    let data = {}
    if (this.showActiveRates) {
      data = { filter: "active" }
    } else {
      data = { filter: "inactive" }
    }
    return $.get(this.namedRateUrl, data, (namedRates) => {
      this.setState({ namedRates })
    })
  }

  newSpaceRate() {
    this.setState({ spaceRateModalOpen: true, selectedSpaceRate: null })
  }

  newRate() {
    this.setState({ rateModalOpen: true, selectedRate: null })
  }

  closeSpaceRateModal() {
    this.setState({
      spaceRateModalOpen: false,
      selectedSpaceRate: null,
      spaceRateFormErrorMessage: null,
    })
    this.fetchSpaceRates()
  }

  closeRateModal() {
    this.setState({
      rateModalOpen: false,
      selectedRate: null,
      rateFormErrorMessage: null,
    })
    this.fetchNamedRates()
  }

  closeRateCalendarModal() {
    this.setState({
      rateCalendar: null,
    })
  }

  expandSpaceRate(spaceRate) {
    this.setState({ spaceRateModalOpen: true, selectedSpaceRate: spaceRate })
  }

  expandRate(rate) {
    this.setState({ rateModalOpen: true, selectedRate: rate })
  }

  saveSpaceRate() {
    if (this.spaceRateForm) {
      this.setState({ spaceRateFormErrorMessage: null })
      const formData = {
        ...this.spaceRateForm.serialize(),
      }

      let verb = "post"
      let url = this.spaceRateUrl
      if (this.state.selectedSpaceRate) {
        verb = "put"
        url = url + "/" + this.state.selectedSpaceRate.id
      }

      $.ajax({
        url,
        data: JSON.stringify(formData),
        type: verb,
        dataType: "json",
        contentType: "application/json",
        success: (result) => this.closeSpaceRateModal(),
        error: (data) => {
          this.setState({
            spaceRateFormErrorMessage:
              data.responseJSON.errors ||
              "There was an error saving, please try again or contact support.",
          })
        },
      })
    }
  }

  deleteSpaceRate(id) {
    const verb = "delete"
    const url = this.spaceRateUrl + "/" + id

    $.ajax({
      url,
      data: "",
      type: verb,
      dataType: "json",
      contentType: "application/json",
      success: (result) => this.closeSpaceRateModal(),
    })
  }

  clickSpaceRate(spaceRate) {
    if (this.props.nightlyRatesEditable) {
      this.expandSpaceRate(spaceRate)
    }
  }

  clickRate(rate) {
    this.expandRate(rate)
  }

  spaceRateAction(spaceRate) {
    if (!this.props.nightlyRatesEditable) {
      return null
    }
    if (spaceRate.deleted) {
      return (
        <div className="bs-mt-2 float-right">
          <Badge color="critical" text="Deleted" />
        </div>
      )
    } else if (this.showActiveRates) {
      return (
        <i className="fa-solid fa-pen-to-square bs-ml-2 float-right cursor-pointer" />
      )
    } else {
      return (
        <a
          className="float-right cursor-pointer"
          onClick={() => this.deleteSpaceRate(spaceRate.id)}
        >
          Delete
        </a>
      )
    }
  }

  saveRate() {
    if (this.rateForm) {
      this.setState({ rateFormErrorMessage: null })
      const formData = {
        ...this.rateForm.serialize(),
      }

      let verb = "post"
      let url = this.namedRateUrl
      if (this.state.selectedRate) {
        verb = "put"
        url = url + "/" + this.state.selectedRate.id
      }

      $.ajax({
        url,
        data: JSON.stringify(formData),
        type: verb,
        dataType: "json",
        contentType: "application/json",
        success: (result) => this.closeRateModal(),
        error: (data) => {
          this.setState({
            rateFormErrorMessage:
              data.responseJSON.errors ||
              "There was an error saving, please try again or contact support.",
          })
        },
      })
    }
  }

  rateAction() {
    if (this.showActiveRates) {
      return (
        <i className="fa-solid fa-pen-to-square bs-ml-2 float-right cursor-pointer" />
      )
    }
  }

  renderSpaceRate(spaceRate) {
    const weekdayRate = spaceRate.rates.monday
    const weekendDay = spaceRate.weekend_days[0] || "saturday"
    const weekendRate = spaceRate.rates[weekendDay]
    let intervalLabel = "Weekday"
    const showWeekendRate =
      spaceRate.timeframe === "nightly" || spaceRate.timeframe === "temporary"

    if (!showWeekendRate) {
      intervalLabel = "Per night"
    }

    return (
      <div
        className={classNames("pricing-item", {
          "deleted-rate": spaceRate.deleted,
        })}
        key={spaceRate.id}
        onClick={() => this.clickSpaceRate(spaceRate)}
        role="button"
      >
        <div className="price-header">
          <span className="float-left text-left">
            LOA: {inchesToFeet(spaceRate.min_length)}&apos; -{" "}
            {inchesToFeet(spaceRate.max_length)}&apos;
          </span>
          {this.spaceRateAction(spaceRate)}
        </div>
        <hr />
        <span>
          {capitalizeFirstLetter(spaceRate.timeframe)}{" "}
          {spaceRate.rate_type.replace("_", " ")} rate
        </span>
        <div className="prices">
          <div>
            <div>{intervalLabel}</div>
            <div className="price-value">
              {formatCurrencyFromMinorUnits({
                amount: weekdayRate,
                currency: this.presentmentCurrency,
              })}
            </div>
          </div>
          {showWeekendRate && (
            <div className="pr-4">
              <div>Weekend</div>
              <div className="price-value">
                {formatCurrencyFromMinorUnits({
                  amount: weekendRate,
                  currency: this.presentmentCurrency,
                })}
              </div>
            </div>
          )}
        </div>
        <hr />
        <span>
          {moment.utc(spaceRate.start_date).format("L")} -{" "}
          {moment.utc(spaceRate.end_date).format("L")}
        </span>
      </div>
    )
  }

  renderRate(rate) {
    return (
      <div
        className="pricing-item pricing-item-rate"
        key={rate.id}
        onClick={() => this.clickRate(rate)}
        role="button"
      >
        <div className="mb-3">
          <div className="price-header">
            <div className="text-left">{rate.name}</div>
            {this.rateAction()}
          </div>
        </div>
        <hr />
        <div className="price-expanded my-4">
          <span className="price-emphasized">{rate.amount_text}</span>
          <span>{rate.pricing_installment_text}</span>
        </div>
        <hr />
        <div className="mt-3">
          {rate.billing_cycle_text.charAt(0).toUpperCase() +
            rate.billing_cycle_text.slice(1)}
        </div>
      </div>
    )
  }

  toggleChange(togglePosition) {
    this.setState(
      {
        togglePosition,
      },
      () => {
        this.fetchRates()
      }
    )
  }

  renderRateCalendar() {
    if (this.state.rateCalendar) {
      return (
        <Modal
          isOpen={true}
          onClose={() => this.closeRateCalendarModal()}
          className="rate-calendar-modal"
        >
          <Modal.Header title="Rate Calendar" />
          <Modal.Body>
            <RateCalendar />
          </Modal.Body>
          <Modal.Footer
            cancelBtnText="Close"
            onlyCancel={true}
            onClose={() => this.closeRateCalendarModal()}
          />
        </Modal>
      )
    }
  }

  renderSpaceRateModal() {
    if (this.state.spaceRateModalOpen) {
      return (
        <Modal isOpen={true} onClose={() => this.closeSpaceRateModal()}>
          <Modal.Header title="New Marketplace Rate" />
          <Modal.Body>
            <SpaceRateForm
              ref={(ref) => {
                this.spaceRateForm = ref
              }}
              selectedSpaceRate={this.state.selectedSpaceRate}
              deleteSpaceRate={this.deleteSpaceRate}
              errorMessage={this.state.spaceRateFormErrorMessage}
            />
          </Modal.Body>
          <Modal.Footer
            cancelBtnText="Cancel"
            confirmBtnText="Save"
            onClose={() => this.closeSpaceRateModal()}
            onSubmit={this.saveSpaceRate}
          />
        </Modal>
      )
    }
  }

  renderRateModal() {
    if (this.state.rateModalOpen) {
      return (
        <Modal isOpen={true} onClose={() => this.closeRateModal()}>
          <Modal.Header
            title={this.state.selectedRate ? "Edit Rate" : "New Rate"}
          />
          <Modal.Body>
            <RateForm
              ref={(ref) => {
                this.rateForm = ref
              }}
              pricingStructures={this.props.pricingStructures}
              billingCycles={this.props.billingCycles}
              selectedRate={this.state.selectedRate}
              errorMessage={this.state.rateFormErrorMessage}
              saveRate={this.saveRate}
              mbmTransientEnabled={this.props.mbmTransientEnabled}
            />
          </Modal.Body>
          <Modal.Footer
            cancelBtnText="Cancel"
            confirmBtnText="Save"
            onClose={() => this.closeRateModal()}
            onSubmit={this.saveRate}
          />
        </Modal>
      )
    }
  }

  renderAddRateLink() {
    if (this.showActiveRates) {
      return (
        <span className="pricing--new-rate-link pull-right">
          <div
            onClick={() => {
              this.newRate()
            }}
          >
            <span>+</span> Add new rate
          </div>
        </span>
      )
    }
  }

  renderAddSpaceRateLink() {
    if (this.showActiveRates) {
      if (this.props.nightlyRatesEditable) {
        return (
          <span className="pricing--new-rate-link pull-right">
            <div
              onClick={() => {
                this.newSpaceRate()
              }}
            >
              <span>+</span> Add new rate
            </div>
          </span>
        )
      } else {
        return (
          <span
            className="pricing--new-rate-link pull-right"
            data-toggle="tooltip"
            data-placement="top"
            title="Contact Dockwa to adjust marketplace rates."
          >
            <div className="text-muted">
              <span>+</span> Add new rate
            </div>
          </span>
        )
      }
    }
  }

  renderNamedRateSection() {
    return (
      <div className="pricing-group">
        {this.renderAddRateLink()}
        <h4 className="mt-0">Installment Rates</h4>
        <div className="pricing-explain-text mb-4">
          These rates are used to create regularly scheduled billing plans. They
          are available for marina use only
          <br />
          when creating seasonal and annual reservations via{" "}
          <a
            target="_blank"
            rel="noopener noreferrer"
            className="pricing-explain-link"
            href={this.props.newManageReservationUrl}
          >
            the dock office reservation form
          </a>{" "}
          and{" "}
          <a
            target="_blank"
            rel="noopener noreferrer"
            className="pricing-explain-link"
            href={`${this.baseUrl}/contract_groups`}
          >
            the contract tool
          </a>
          .
        </div>
        <div className="pricing-items">
          {(this.state.namedRates || []).map(this.renderRate)}
        </div>
      </div>
    )
  }

  render() {
    const dockageSpaceRates = (this.state.spaceRates || [])
      .filter((spaceRate) => spaceRate.space_type === "Dock")
      .sort((a, b) => new Date(a.updated_at) - new Date(b.updated_at))
      .reverse()

    const mooringSpaceRates = (this.state.spaceRates || [])
      .filter((spaceRate) => spaceRate.space_type === "Mooring")
      .sort((a, b) => new Date(a.updated_at) - new Date(b.updated_at))
      .reverse()

    const ctaButton = this.props.transientRatesV2Enabled ? (
      <a
        className="btn btn-primary float-right"
        href={this.props.transientRatesV2Url}
      >
        Manage Transient Rates
      </a>
    ) : (
      <div
        className="btn btn-secondary float-right"
        onClick={() => {
          this.setState({ rateCalendar: true })
        }}
      >
        Rate Calendar
      </div>
    )

    return (
      <div className="pricing-controller">
        <div className="row">
          <div className="col-sm-6 col-sm-offset-3">
            <ToggleSwitch
              labelLeft="Active Rates"
              labelRight="Past Rates"
              tellParent={this.toggleChange}
              startPosition={this.state.togglePosition}
              additionalCssClasses="mega"
            />
          </div>
          <div className="col-sm-3">{ctaButton}</div>
        </div>

        {this.renderRateModal()}
        {this.renderSpaceRateModal()}
        {this.renderRateCalendar()}

        {!this.props.transientRatesV2Enabled && (
          <div className="pricing-group">
            {this.renderAddSpaceRateLink()}
            <h4 className="mt-0">Nightly Rates</h4>
            <div className="pricing-explain-text">
              These rates are adjusted based on setting a price per night and
              are used to calculate costs on{" "}
              <a
                target="_blank"
                rel="noopener noreferrer"
                className="pricing-explain-link"
                href={this.props.destinationUrl}
              >
                the boater marketplace booking form
              </a>{" "}
              and{" "}
              <a
                target="_blank"
                rel="noopener noreferrer"
                className="pricing-explain-link"
                href={this.props.newManageReservationUrl}
              >
                the dock office reservation form
              </a>
              . Nightly rates can only be edited by Dockwa employees.
            </div>

            <a
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-primary mt-2"
              href={this.props.rateUpdateFormUrl}
            >
              Request Rate Updates
            </a>

            <h4 className="mt-5">Docks</h4>
            <div className="pricing-items">
              {dockageSpaceRates.map(this.renderSpaceRate)}
            </div>
            <h4 className="mt-5">Moorings</h4>
            <div className="pricing-items">
              {mooringSpaceRates.map(this.renderSpaceRate)}
            </div>
          </div>
        )}
        {this.renderNamedRateSection()}
      </div>
    )
  }
}

PricingController.propTypes = {
  marinaSlug: PropTypes.string.isRequired,
  nightlyRatesEditable: PropTypes.bool,
  transientRatesV2Enabled: PropTypes.bool,
  transientRatesV2Url: PropTypes.string,
  pricingStructures: PropTypes.object.isRequired,
  billingCycles: PropTypes.array.isRequired,
  newManageReservationUrl: PropTypes.string.isRequired,
  destinationUrl: PropTypes.string,
  rateUpdateFormUrl: PropTypes.string,
  mbmTransientEnabled: PropTypes.bool,
}

export default PricingController
